<template>
  <SearchPage
    path="/lastminute/"
    :pagedata="null"
    :pagination-current-page="1"
    :flex-search="false"
    :show-only-lastminute-objects="true"
  />
</template>

<script setup>
definePageMeta({
  layout: 'search'
})
</script>
